import {
  ActionButton,
  Label,
  mergeStyleSets,
  Stack,
  TextField,
} from '@fluentui/react';
import { Dialog, DialogType } from '@fluentui/react/lib/Dialog';
import { useContext, useState } from 'react';

import AppContext from './AppContext';
import { useAtom } from 'jotai';
import { profileDataAtom } from '../atoms/authAtoms';
import { authorize, authorizeResponse } from '../services/authService';

const Profile = () => {
  const dialogContentProps = {
    type: DialogType.normal,
    title: 'Profile',
    closeButtonAriaLabel: 'Close',
  };

  const [error, setError] = useState<string>('');
  const context = useContext(AppContext);
  const [profileData, setProfileData] = useAtom(profileDataAtom);
  const styles = mergeStyleSets({
    labelColumn: {
      width: '100px',
    },
  });
  return (
    <>
      <Dialog
        hidden={!context.isProfileDialogOpen}
        onDismiss={() => context.setIsProfileDialogOpen(false)}
        dialogContentProps={dialogContentProps}
      >
        <Stack tokens={{ childrenGap: 5 }}>
          <Stack horizontal>
            <Label className={styles.labelColumn}>First Name: </Label>
            <TextField
              data-testid="firstNameText"
              readOnly
              value={profileData.givenName}
              borderless
            ></TextField>
          </Stack>
          <Stack horizontal>
            <Label className={styles.labelColumn}>Last Name: </Label>
            <TextField
              data-testid="lastNameText"
              readOnly
              value={profileData.surname}
              borderless
            ></TextField>
          </Stack>
          <Stack horizontal>
            <Label className={styles.labelColumn}>Username: </Label>
            <TextField
              data-testid="emailText"
              readOnly
              value={profileData.userPrincipalName}
              borderless
            ></TextField>
          </Stack>
          <Stack horizontal>
            <Label className={styles.labelColumn}>Email: </Label>
            <TextField
              data-testid="emailText"
              readOnly
              value={profileData.userPrincipalName}
              borderless
            ></TextField>
          </Stack>
          <Stack horizontal>
            <Label className={styles.labelColumn}>Id: </Label>
            <TextField
              data-testid="idText"
              readOnly
              value={profileData.id}
              borderless
            ></TextField>
          </Stack>
          <Stack>
            <ActionButton
              iconProps={{ iconName: 'Refresh' }}
              onClick={() => {
                const abortController = new AbortController();
                authorize(abortController, {
                  username: profileData.userPrincipalName,
                })
                  .then((data: authorizeResponse) => {
                    if (data?.token) {
                      localStorage.setItem('token', data.token);
                    }
                    profileData.permissions = data.permissions;
                    profileData.tenants = data.tenants;
                    profileData.currentTenant = data.currentTenant;
                    setProfileData(profileData);
                    setError('');
                  })
                  .catch((error) => {
                    setError('Error reloading permissions');
                    console.error('Error reloading permissions:', error);
                  });
              }}
            >
              Reload Permissions
            </ActionButton>
            <TextField
              readOnly
              hidden={error === ''}
              value={error}
              style={{ color: 'red' }}
              borderless
            />
          </Stack>
        </Stack>
      </Dialog>
    </>
  );
};

export default Profile;
